import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface CorrectionStatusIconProps {
	icon: string;
	tooltip: string;
	color: string;
}

const CorrectionStatusIcon: React.FC<CorrectionStatusIconProps> = ({ icon, tooltip, color }) => {
	return (
		<OverlayTrigger placement="top" overlay={<Tooltip id="correction-status-tooltip">{tooltip}</Tooltip>}>
			<div
				style={{
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					width: "24px",
					height: "24px",
					borderRadius: "50%",
					backgroundColor: color,
					cursor: "default",
				}}
			>
				<i className={`fa ${icon}`} style={{ color: "#FFFFFF", fontSize: "14px" }}></i>
			</div>
		</OverlayTrigger>
	);
};

export default CorrectionStatusIcon;
